import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=6a87f99b&"
import script from "./Claims.vue?vue&type=script&lang=js&"
export * from "./Claims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports